import { Component, OnInit, Injector } from '@angular/core';
import { OrganizationUser } from 'app/core/interfaces/organizationUser';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { OrganizationUserDetailsComponent } from './details/users-details.component';
import { OrganizationUserRegistrationComponent } from './registration/users-registration.component';
import { OrganizationSubUsersService } from 'app/core/http/services/organizationSubUsers.service';

@Component({
  selector: 'page-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class OrganizationUsersComponent extends BaseComponent implements OnInit {
  public organizationUsers: OrganizationUser[] = [];
  public activeOrganizationUsers: OrganizationUser[] = [];
  public inactiveOrganizationUsers: OrganizationUser[] = [];
  public title: string = 'Usuários da organização';
  private organizationId: string = '';

  constructor(private injector: Injector, private organizationSubUsersService: OrganizationSubUsersService) {
    super(injector);
  }

  ngOnInit(): void {
    this.organizationId = this.auth.currentUserValue.user.id;
    this.getUsers();
  }

  getUsers() {
    this.organizationSubUsersService.getOrganizationSubUsers(this.organizationId).subscribe({
      next: (organizationSubUsers: any) => {
        this.organizationUsers = organizationSubUsers;
        this.filterOrganizationUsers();
      },
      error: (err) => console.log(err),
    });
  }

  filterOrganizationUsers() {
    this.activeOrganizationUsers = this.organizationUsers.filter((user) => user.active);
    this.inactiveOrganizationUsers = this.organizationUsers.filter((user) => !user.active);
  }

  openOrganizationUserDetails(user: OrganizationUser) {
    const data = {
      param: { user: user },
    };

    this.dialog.openComponentDialog(OrganizationUserDetailsComponent, data);
  }

  openOrganizationUserRegistration() {
    const dialogConfig = {
      width: '800px',
      height: '675px',
    };

    this.dialog.openComponentDialog(OrganizationUserRegistrationComponent, null, dialogConfig);
  }
}
